<div *ngIf="isLoading" class="overlay"></div>
<div *ngIf="isLoading" class="loader"></div>
<div *ngIf="!isLoading" class="example-inner">
<div class="container">
  <div class="header">
      <button mat-raised-button 
            color="primary" 
            class="dashboard-button" 
            routerLink="/sales/generaldash">
      <mat-icon>dashboard</mat-icon>
      <span>Sales Dashboard</span>
      </button>
      <h1 class="page-title" >General Overview</h1>
  </div>

  <form [formGroup]="yearForm">
    <div class="year-selector">
      <mat-form-field appearance="outline">
        <mat-label>Select Year</mat-label>
        <input matInput
               type="number"
               formControlName="year"
               (change)="onYearChange()"
               [max]="currentYear"
               [min]="2000">
      </mat-form-field>
    </div>
  </form>

  <div class="demo-container">
          
    <div style="background-color: lightcyan;">
      <span><strong>Total Current Vs Last Year</strong></span>
      <kendo-grid
        [data]="gridDataTab1"
        [height]="520"
        [pageSize]="gridStateTab1.take"
        [skip]="gridStateTab1.skip"
        [pageable]="false"
        [sortable]="false"
      >
      <kendo-grid-column field="month" title="Month"></kendo-grid-column>
      <kendo-grid-column field="salesCurrent" [title]="'Sales ' + selectedYear" format="£ ##,###">
        <ng-template kendoGridFooterTemplate>
          <span style='float: right'>
            {{ totalTab1Now["salesCurrent"].sum.toFixed(0) | currency:'GBP' }}
          </span>
        </ng-template> 
      </kendo-grid-column>
      <kendo-grid-column field="salesLY" title="Sales LY" format="£ ##,###">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalTab1Now["salesLY"].sum.toFixed(0) | currency:'GBP' }}
          </span>
        </ng-template> 
      </kendo-grid-column>
      <kendo-grid-column field="salesPercent" title="% Diff" format="###"></kendo-grid-column>
      </kendo-grid>
    </div>
    <div style="background-color: lightcyan;">
      <span><strong>Stores</strong></span>
      <kendo-grid
        [data]="gridDataTab2"
        [height]="520"
        [pageSize]="gridStateTab2.take"
        [skip]="gridStateTab2.skip"
        [pageable]="false"
        [sortable]="false"
      >
      <kendo-grid-column field="month" title="Month">
      </kendo-grid-column>
      <kendo-grid-column field="creams" title="Creams" format="£ ##,###.">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalTab2["creams"].sum.toFixed(0) | currency:'GBP' }}
          </span>
        </ng-template> 
      </kendo-grid-column>
      <kendo-grid-column field="mh" title="MH" format="£ ##,###">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalTab2["mh"].sum.toFixed(0) | currency:'GBP' }}
          </span>
        </ng-template> 
      </kendo-grid-column>
      <kendo-grid-column field="dishd" title="Dishd" format="£ ##,###">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalTab2["dishd"].sum.toFixed(0) | currency:'GBP' }}
          </span>
        </ng-template> 
      </kendo-grid-column>
      <kendo-grid-column field="cart" title="Cart" format="£ ##,###">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalTab2["cart"].sum.toFixed(0) | currency:'GBP' }}
          </span>
        </ng-template> 
      </kendo-grid-column>
      <kendo-grid-column field="totalSales" title="Total Sales" format="£ ##,###">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalTab2["totalSales"].sum.toFixed(0) | currency:'GBP' }}
          </span>
        </ng-template> 
      </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>
  <br/><br/>
    <div class="demo-container">
    <div style="background-color: lightcyan;">
      <span><strong>Dine In / Delivery</strong></span>
      <kendo-grid
        [data]="gridDataTab3"
        [height]="520"
        [pageSize]="gridStateTab3.take"
        [skip]="gridStateTab3.skip"
        [pageable]="false"
        [sortable]="false"
      >
      <kendo-grid-column field="month" title="Month"></kendo-grid-column>
      <kendo-grid-column field="dineInSales" title="Dine In" format="£ ##,###">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalTab3["dineInSales"].sum.toFixed(0) | currency:'GBP' }}
          </span>
        </ng-template> 
      </kendo-grid-column>
      <kendo-grid-column field="deliverySales" title="Delivery" format="£ ##,###">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalTab3["deliverySales"].sum.toFixed(0) | currency:'GBP' }}
          </span>
        </ng-template> 
      </kendo-grid-column>
      <kendo-grid-column field="totalSales" title="Total Sales" format="£ ##,###">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalTab3["totalSales"].sum.toFixed(0) | currency:'GBP' }}
          </span>
        </ng-template> 
      </kendo-grid-column>
      </kendo-grid>
    </div>
    <div style="background-color: lightcyan;">
      <span><strong>Transactions</strong></span>
      <kendo-grid
        [data]="gridDataTab4"
        [height]="520"
        [pageSize]="gridStateTab4.take"
        [skip]="gridStateTab4.skip"
        [pageable]="false"
        [sortable]="false"
      >
      <kendo-grid-column field="month" title="Month"></kendo-grid-column>
      <kendo-grid-column field="transactionsCurrent" title="Trans YTD">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalTab4["transactionsCurrent"].sum.toFixed(0) }}
          </span>
        </ng-template> 
      </kendo-grid-column>
      <kendo-grid-column field="transactionsLY" title="Trans LY">
        <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
          <span style='float: right'>
            {{ totalTab4["transactionsLY"].sum.toFixed(0) }}
          </span>
        </ng-template> 
      </kendo-grid-column>
      <kendo-grid-column field="transactionsPercent" title="% Diff" format="###.##"></kendo-grid-column>
      </kendo-grid>
    </div>
  </div>

  <br/><br/>
      <div class="demo-container">
      <div style="background-color: lightcyan;">
        <span><strong>Stock Cost</strong></span>
        <kendo-grid
          [data]="gridDataTab5"
          [height]="200"
          [pageSize]="gridStateTab5.take"
          [skip]="gridStateTab5.skip"
          [pageable]="false"
          [sortable]="false"
        >
        <kendo-grid-column field="store" title="Store"></kendo-grid-column>
        <kendo-grid-column field="totalCost" title="Total Cost" format="£ ##,###">
          <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
            <span style='float: right'>
              {{ totalTab5["totalCost"].sum.toFixed(0) | currency:'GBP' }}
            </span>
          </ng-template> 
        </kendo-grid-column>
        <kendo-grid-column field="totalStockItems" title="Total Items" format="###,###">
        </kendo-grid-column>
        </kendo-grid>
      </div>
      <div style="background-color: lightcyan;">
      </div>
    </div>
</div> 
</div>